import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Package} from "../../model/Package";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProvidedService {

  urlProvided: string = '/provided';

  constructor(private http: HttpClient) { }

  public getProvidedPackagesPagination(page): Observable<any> {
    return this.http.get<Package>(`${environment.packagesManagerBackendUrl}` + this.urlProvided + '/page/' + page);
  }
}
